<template>
  <div :class="[baseClass, modifierClasses]">
    <div v-if="$slots.content">
      <slot name="content"></slot>
    </div>
    <div v-if="$slots.actions">
      <slot name="actions"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    variants: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: 'div',
    },
  },
  data() {
    return {
      baseClass: 'section-header',
    };
  },
  computed: {
    modifiers() {
      const variants = this.variants && this.variants.length > 0 ? this.variants.split(' ') : [];
      return [this.size, ...variants];
    },
    modifierClasses() {
      return this.modifiers.map((variant) => `${this.baseClass}--${variant}`).join(' ');
    },
  },
};
</script>
